import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {TaskStatusIds, documentTypes, HttpStatusCodes} from '../../util/uiconstants';
import qs from 'query-string';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function taskRelatedEntitiesReducer(state = initialState.taskRelatedEntities, action) {
	switch (action.type) {
		case types.GET_TASK_DETAILS: {
			if (action.response) {
				if (action.response?.relatedEntities) {
					return action.response?.relatedEntities;
				} else {
					return [];
				}
			}
			return state;
		}
		case types.GET_TASK_RELATED_ENTITIES: {
			if (action.response) {
				return action.response;
			}
			return state;
		}
		case types.CREATE_TASK_ENTITY_RELATION:
			if (action?.response) {
				const id = action.response[0];
				if (id == action.payload.id) {
					const newRelEntity = {
						stEntityId: id,
						stEntityShortName: action.payload.stEntityShortName,
						stEntityName: action.payload.stEntityName
					};
					const taskEntities = [...state, newRelEntity];
					return taskEntities;
				}
			}
			return state;
		case types.DELETE_TASK_ALL_MULTIENTITIES:
			if (action?.responseObj?.status === HttpStatusCodes.NoContent) {
				return [];
			}
			return state;

		case types.DELETE_TASK_ENTITY_RELATION:
			if (action?.responseObj?.status === HttpStatusCodes.NoContent) {
				if (action.payload) {
					const filteredEntities = state.filter((x) => x.stEntityId != action.payload);
					return filteredEntities;
				}
			}
			return state;
		default:
			return state;
	}
}
